import { createIcon } from '@chakra-ui/react'

export const OGIcon = createIcon({
  displayName: 'OGIcon',
  path: (
    <g clipPath='url(#clip0_2607_753)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.75037 11.25H5.25037C4.83637 11.25 4.50037 10.914 4.50037 10.5V7.5C4.50037 7.086 4.83637 6.75 5.25037 6.75H6.75037C7.16437 6.75 7.50037 7.086 7.50037 7.5V10.5C7.50037 10.914 7.16437 11.25 6.75037 11.25Z'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.7504 15H2.25037C1.42237 15 0.750366 14.328 0.750366 13.5V4.5C0.750366 3.672 1.42237 3 2.25037 3H15.7504C16.5784 3 17.2504 3.672 17.2504 4.5V13.5C17.2504 14.328 16.5784 15 15.7504 15Z'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
      <path
        d='M13.5004 7.5C13.5004 7.086 13.1644 6.75 12.7504 6.75H11.2504C10.8364 6.75 10.5004 7.086 10.5004 7.5V10.5C10.5004 10.914 10.8364 11.25 11.2504 11.25H12.7504C13.1644 11.25 13.5004 10.9141 13.5004 10.5V9.75H12.7504'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
      <defs>
        <clipPath id='clip0_2607_753'>
          <rect width='18' height='18' fill='white' />
        </clipPath>
      </defs>
    </g>
  ),
  viewBox: '0 0 18 18',
})
